import { FormControl } from '@angular/forms';

export class NumberValidator {
    static valid(control: FormControl) {
        if (control.value == null || control.value === '' || control.value === undefined) {
            return null;
        }

        const regEx = /^([0-9]+)$/i;
        const valid = regEx.test(control.value);

        if (!valid) {
            return {
                email: 'Only numberic allowed',
            };
        }

        return null;
    }
}

